import React from "react";

const defaultEmissionsMeasurementTE = [
  {
    typeLabelTE: "Scope 1",
    amountMetricTonnesTE: "",
    methodUsedTE: "",
    measurementApproachTE: "",
  },
  {
    typeLabelTE: "Scope 2 (location-based)",
    amountMetricTonnesTE: "",
    methodUsedTE: "",
    measurementApproachTE: "",
  },
  {
    typeLabelTE: "Scope 2 (market-based)",
    amountMetricTonnesTE: "",
    methodUsedTE: "",
    measurementApproachTE: "",
  },
  {
    typeLabelTE: "Scope 3",
    amountMetricTonnesTE: "",
    methodUsedTE: "",
    measurementApproachTE: "",
  },
];

const EmissionsMeasurementTable = ({
  emissionsMeasurementTE,
  setEmissionsMeasurementTE,
}) => {
  const handleChange = (i, field, value) => {
    const updated = [...emissionsMeasurementTE];
    updated[i][field] = value;
    setEmissionsMeasurementTE(updated);
  };

  // no per-cell borders (CSS below draws them + hides outer edges)
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };
  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };
  const leftLabelCell = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: 600,
  };
  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid gray",
    borderRadius: "6px",
    fontSize: "14px",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        borderRadius: 12,
        overflow: "hidden",
        border: "1px solid #000", // outer frame for perfect rounded corners
      }}
    >
      {/* Inner grid + hide outer edges so corners align perfectly */}
      <style>{`
        .emTable{
          width: 100%;
          border-collapse: collapse;
        }
        .emTable th,
        .emTable td{
          border: 1px solid #000;
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .emTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide outer edges (the wrapper's border draws them) */
        .emTable thead tr:first-child th{ border-top: 0; }
        .emTable tr th:first-child,
        .emTable tr td:first-child{ border-left: 0; }
        .emTable tr th:last-child,
        .emTable tr td:last-child{ border-right: 0; }
        .emTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <table className="emTable">
        <thead>
          <tr>
            <th style={header}>Type of emissions</th>
            <th style={header}>Amount (metric tonnes)</th>
            <th style={header}>Method used</th>
            <th style={header}>
              Measurement approach
              <br />
              (brief description)
            </th>
          </tr>
        </thead>

        <tbody>
          {emissionsMeasurementTE.map((row, idx) => (
            <tr key={idx}>
              <td style={leftLabelCell}>{row.typeLabelTE}</td>
              <td style={cell}>
                <input
                  style={inputStyle}
                  placeholder="Enter data"
                  value={row.amountMetricTonnesTE}
                  onChange={(e) =>
                    handleChange(idx, "amountMetricTonnesTE", e.target.value)
                  }
                />
              </td>
              <td style={cell}>
                <input
                  style={inputStyle}
                  placeholder="Enter data"
                  value={row.methodUsedTE}
                  onChange={(e) =>
                    handleChange(idx, "methodUsedTE", e.target.value)
                  }
                />
              </td>
              <td style={cell}>
                <input
                  style={inputStyle}
                  placeholder="Enter data"
                  value={row.measurementApproachTE}
                  onChange={(e) =>
                    handleChange(idx, "measurementApproachTE", e.target.value)
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EmissionsMeasurementTable;
